import React, { FC, useEffect, useState} from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import {CircularProgress} from "@material-ui/core";

type Props = {
    snackbar: {
        message: string,
        open: boolean,
        severity: 'info' | 'success' | 'error'
    },
    setSnackbar: React.Dispatch<{
        message: string,
        open: boolean,
        severity: 'info' | 'success' | 'error'
    }>
}

function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const SimpleSnackbar: FC<Props> = ({ snackbar , setSnackbar}) => {
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const { message, open, severity } = snackbar

    useEffect(() => {
        setOpenSnackbar(open)
    }, [open])

    const getAlert = (severity: string) => {
        if(severity === 'info') {
            return <Alert icon={<CircularProgress color="inherit" size={"22px"} />} severity="info">Waiting for response...</Alert>
        }
        if (severity === 'success') {
            return <Alert severity={severity}>{message}</Alert>
        }
        if (severity === 'error') {
            return <Alert severity={severity}>{message}</Alert>
        }
    }

    return (
        <div>
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                open={openSnackbar}

                autoHideDuration={4000}
                onClose={() => setSnackbar({ message: snackbar.message, open: false, severity: 'success'})}
            >
                { getAlert(severity) }
            </Snackbar>
        </div>
    );
}

export default SimpleSnackbar
